import { useEffect } from 'react'

import { useAppSettings } from '@/stores/useAppSettings'

/**
 * Component to dynamically update favicon and apple-touch-icon based on branding settings
 * Works for both authenticated and non-authenticated users
 */
export function DynamicFavicon() {
  const settings = useAppSettings((state) => state.settings)
  const getSetting = useAppSettings((state) => state.getSetting)

  useEffect(() => {
    const faviconUrl = getSetting<string>('branding.favicon_url')
    const mobileLogo = getSetting<string>('branding.mobile_logo_url')

    // Update favicon
    if (faviconUrl && typeof faviconUrl === 'string' && faviconUrl.trim()) {
      const favicon = document.querySelector("link[rel='icon']") as HTMLLinkElement
      if (favicon) {
        favicon.href = faviconUrl
      } else {
        const newFavicon = document.createElement('link')
        newFavicon.rel = 'icon'
        newFavicon.type = 'image/png'
        newFavicon.href = faviconUrl
        document.head.appendChild(newFavicon)
      }
    }

    // Update apple-touch-icon (for iOS home screen)
    if (mobileLogo && typeof mobileLogo === 'string' && mobileLogo.trim()) {
      const appleTouchIcon = document.querySelector("link[rel='apple-touch-icon']") as HTMLLinkElement
      if (appleTouchIcon) {
        appleTouchIcon.href = mobileLogo
      } else {
        const newAppleTouchIcon = document.createElement('link')
        newAppleTouchIcon.rel = 'apple-touch-icon'
        newAppleTouchIcon.sizes = '180x180'
        newAppleTouchIcon.href = mobileLogo
        document.head.appendChild(newAppleTouchIcon)
      }
    }
  }, [settings, getSetting])

  return null // This component doesn't render anything
}
